import script from "./userAuditAystem.vue?vue&type=script&setup=true&lang=js"
export * from "./userAuditAystem.vue?vue&type=script&setup=true&lang=js"

import "./userAuditAystem.vue?vue&type=style&index=0&id=7231e7e6&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/manga-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7231e7e6"]])

export default __exports__